import { z } from 'zod'

export const MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION = '1.0.1' as const
const numericString = z.string().regex(/^[0-9]+$/)
const productKey = z.string().regex(/^[a-z][a-z0-9_-]{0,63}$/)

export const membershipRoleCreateRequestSchema = z.object({
  key: z.string(),
  displayName: z.string(),
  product: z.string(),
  basePermissionIds: z.array(z.string()).optional(),
}).passthrough()

export const membershipRoleMetadataRequestSchema = z.object({
  displayName: z.string().optional(),
  description: z.string().nullable().optional(),
}).passthrough()

export const membershipRoleArchiveRequestSchema = z.object({}).passthrough()
export const membershipRolePermissionsAddRequestSchema = z.object({ permissionIds: z.array(z.string()) }).passthrough()
export const membershipRolePermissionRemoveRequestSchema = z.object({}).passthrough()

const role = z.object({
  id: numericString,
  key: z.string().min(1),
  displayName: z.string().min(1),
  product: productKey,
  isCustom: z.literal(true),
  permissions: z.array(numericString),
}).passthrough()

const roleMetadata = z.object({
  id: numericString,
  key: z.string().min(1),
  displayName: z.string().min(1),
  description: z.string().nullable(),
  product: productKey,
  isCustom: z.literal(true),
}).passthrough()

export const membershipRoleCreateResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION),
  role,
}).passthrough()

export const membershipRoleMetadataResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION),
  role: roleMetadata,
}).passthrough()

export const membershipRoleArchiveResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION),
  archived: z.array(numericString),
}).passthrough()

export const membershipRolePermissionsAddResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION),
  added: z.array(numericString),
  denied: z.array(z.object({
    permissionId: numericString,
    reason: z.enum(['MM_PERMISSION_NOT_ASSIGNABLE_BY_ORG_ADMIN', 'MM_NO_SELF_ESCALATION', 'MM_PRODUCT_SCOPE_MISMATCH']),
  }).passthrough()),
}).passthrough()

export const membershipRolePermissionRemoveResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ROLES_WRITE_CONTRACT_VERSION),
  removed: z.array(numericString),
}).passthrough()

export type MembershipRoleCreateRequest = z.infer<typeof membershipRoleCreateRequestSchema>
export type MembershipRoleMetadataRequest = z.infer<typeof membershipRoleMetadataRequestSchema>
export type MembershipRoleArchiveRequest = z.infer<typeof membershipRoleArchiveRequestSchema>
export type MembershipRolePermissionsAddRequest = z.infer<typeof membershipRolePermissionsAddRequestSchema>
export type MembershipRolePermissionRemoveRequest = z.infer<typeof membershipRolePermissionRemoveRequestSchema>
export type MembershipRoleCreateResponse = z.infer<typeof membershipRoleCreateResponseSchema>
export type MembershipRoleMetadataResponse = z.infer<typeof membershipRoleMetadataResponseSchema>
export type MembershipRoleArchiveResponse = z.infer<typeof membershipRoleArchiveResponseSchema>
export type MembershipRolePermissionsAddResponse = z.infer<typeof membershipRolePermissionsAddResponseSchema>
export type MembershipRolePermissionRemoveResponse = z.infer<typeof membershipRolePermissionRemoveResponseSchema>
